import React, { useState, useEffect } from 'react';
import { useGetList, useDataProvider, Title } from 'react-admin';
import {
    Card, Table, TableHead, TableBody, TableRow, TableCell,
    Switch, FormControlLabel, CircularProgress, makeStyles, Typography
} from '@material-ui/core';

const GIORNI = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

const useStyles = makeStyles({
    card: {
        margin: '1em',
        overflow: 'hidden',
    },
    header: {
        padding: '16px 24px',
        backgroundColor: '#A08F7C',
        color: 'white',
    },
    tableHeadCell: {
        fontWeight: 'bold',
        backgroundColor: '#f5f0eb',
        color: '#4C3920',
        fontSize: '0.9rem',
    },
    dayCell: {
        fontWeight: 600,
        color: '#4C3920',
        width: 140,
    },
    slotCell: {
        width: 200,
    },
    labelFestivo: {
        color: '#A08F7C',
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    labelFeriale: {
        color: '#999',
        fontSize: '0.875rem',
    },
    switch: {
        '& .MuiSwitch-colorPrimary.Mui-checked': {
            color: '#A08F7C',
        },
        '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#A08F7C',
        },
    },
    evenRow: {
        backgroundColor: '#faf8f6',
    },
    oddRow: {
        backgroundColor: '#ffffff',
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        padding: 40,
    },
});

export const SlotConfigList = ({ resource }) => {
    const classes = useStyles();
    const [config, setConfig] = useState({});

    const { data, ids, loading } = useGetList(
        resource,
        { page: 1, perPage: 14 },
        { field: 'giorno_settimana', order: 'ASC' },
        {}
    );

    const dataProvider = useDataProvider();

    useEffect(() => {
        if (!loading && ids.length > 0) {
            const byDay = {};
            ids.forEach(id => {
                const r = data[id];
                if (!byDay[r.giorno_settimana]) byDay[r.giorno_settimana] = {};
                byDay[r.giorno_settimana][r.tipo_slot] = { ...r };
            });
            setConfig(byDay);
        }
    }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleToggle = (giorno, slot) => {
        const record = config[giorno][slot];
        const newValue = !record.festivo_feriale;

        setConfig(prev => ({
            ...prev,
            [giorno]: {
                ...prev[giorno],
                [slot]: { ...record, festivo_feriale: newValue },
            },
        }));

        dataProvider.update(resource, {
            id: record.id,
            data: { festivo_feriale: newValue },
            previousData: record,
        });
    };

    const SlotToggle = ({ giorno, slot }) => {
        const record = config[giorno]?.[slot];
        if (!record) return null;
        const isFestivo = record.festivo_feriale;
        return (
            <FormControlLabel
                control={
                    <Switch
                        className={classes.switch}
                        checked={isFestivo}
                        onChange={() => handleToggle(giorno, slot)}
                        color="primary"
                    />
                }
                label={
                    <span className={isFestivo ? classes.labelFestivo : classes.labelFeriale}>
                        {isFestivo ? 'Festivo' : 'Feriale'}
                    </span>
                }
            />
        );
    };

    return (
        <Card className={classes.card}>
            <Title title="Configurazione Feriale / Festivo" />
            <Typography variant="h6" className={classes.header}>
                Configurazione Feriale / Festivo
            </Typography>

            {loading ? (
                <div className={classes.loading}>
                    <CircularProgress style={{ color: '#A08F7C' }} />
                </div>
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeadCell}>Giorno</TableCell>
                            <TableCell className={classes.tableHeadCell}>Giornaliero</TableCell>
                            <TableCell className={classes.tableHeadCell}>Serale</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {[0, 1, 2, 3, 4, 5, 6].map(g => (
                            <TableRow key={g} className={g % 2 === 0 ? classes.evenRow : classes.oddRow}>
                                <TableCell className={classes.dayCell}>{GIORNI[g]}</TableCell>
                                <TableCell className={classes.slotCell}>
                                    <SlotToggle giorno={g} slot="giornaliero" />
                                </TableCell>
                                <TableCell className={classes.slotCell}>
                                    <SlotToggle giorno={g} slot="serale" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Card>
    );
};
